import { HOSTNAME } from 'common/configuration/constants';

export const isHttps = () => window.location.protocol === 'https:';
export const isNotOnFirstScreen = () =>
  !!(document.referrer && HOSTNAME && document.referrer.indexOf(HOSTNAME) > -1);
